import React from 'react';
import styled from 'styled-components';
import { SceneType } from '@types';
import ImgPano from './img-pano.png';
import ImgPVideo from './img-pvideo.png';
import ImgMatrix from './img-matrix.png';

interface Props {
  type: SceneType;
}

const Icon = styled.img.attrs({
  draggable: 'false',
})`
  position: absolute;
  top: 5px;
  left: 5px;
  width: 26px;
  height: 16px;
`;

function TypeMark({ type }: Props) {
  if (type === SceneType.pano) return <Icon src={ImgPano} />;
  if (type === SceneType.panoVideo) return <Icon src={ImgPVideo} />;
  if (type === SceneType.matrix) return <Icon src={ImgMatrix} />;
  return null;
}

export default TypeMark;
